<template>
  <v-card class="pa-2">
    <v-card-title class="headline justify-center text-center text-break">
      {{ title }}
    </v-card-title>
    <v-card-text v-if="caution" style="margin-bottom: 32px;" class="text-center">
      {{ caution }}
    </v-card-text>

    <v-card-actions style="padding: 16px;">
      <v-spacer />
      <v-btn dark color="secondary" @click="cancelDialog"> Cancel </v-btn>
      <v-btn
        color="primary"
        @click="confirmDialog"
        :disabled="loading"
        :loading="loading"
      >
        {{ confirmationText }}
      </v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    caution: {
      type: String,
      default: null,
    },
    confirmationText: {
      type: String,
      default: 'Ok',
    },
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    cancelDialog() {
      this.$emit('closeCancelParent');
    },
    confirmDialog() {
      this.$emit('confirmParent');
    },
  },
};
</script>
